import { render, staticRenderFns } from "./OnCall.vue?vue&type=template&id=54837698&scoped=true&"
import script from "./OnCall.vue?vue&type=script&lang=js&"
export * from "./OnCall.vue?vue&type=script&lang=js&"
import style0 from "./OnCall.vue?vue&type=style&index=0&id=54837698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54837698",
  null
  
)

export default component.exports